import { TransformedImage } from "~/components/transformed-image.component";

const EMPTY_BASKET_SRC = "/images/empty-basket.png";

export function EmptyCartIcon() {
	return (
		<TransformedImage
			src={EMPTY_BASKET_SRC}
			alt=""
			width={96}
			height={96}
			className="size-24 shrink-0 object-contain"
		/>
	);
}
